import React, { HTMLProps } from 'react';
import { Container } from './styles';

/*
O title será a mensagem de erro
Como o styled components utiliza as class,
para que o Tooltip receba estilização de um
elemento superior, ele tem que receber a className.
O className não pode ser obrigatório pois será passada
pelos estilos que utilizarem.
*/
interface TooltipProps extends HTMLProps<HTMLDivElement> {
  title: string;
  className?: string;
  classNameSpan?: string;
  colorBefore?: string;
}

const Tooltip: React.FC<TooltipProps> = ({
  title,
  className = '',
  classNameSpan = '',
  colorBefore = '',
  children,
  ...rest
}) => {
  return (
    <Container colorBefore={colorBefore} className={className}>
      <span className={classNameSpan} {...rest}>
        {title}
      </span>
      {children}
    </Container>
  );
};

export default Tooltip;
